import { LayoutChangeEvent, Platform, View, StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { IconButton } from "../styled";
import { Props } from "./types";

const styles = StyleSheet.create({
  // @ts-ignore
  stickyHeader: {
    ...Platform.select({
      web: {
        zIndex: 10,
        backgroundColor: "white",
        position: "sticky",
        top: 0,
      },
    }),
  },
});

export default function ModalHeader({
  title,
  onDismiss,
  onLayout,
  hasBorder,
}: Pick<Props, "title" | "onDismiss" | "hasBorder"> & { onLayout?(e: LayoutChangeEvent): void }) {
  return !onDismiss ? (
    <View className="h-2" />
  ) : (
    <View
      className={`flex-row items-center justify-between bg-white rounded-t-2xl ${hasBorder && "border-b border-b-sky"}`}
      onLayout={onLayout}
      style={styles.stickyHeader}
    >
      <View className="flex-1">
        <IconButton icon="x" onPress={onDismiss} />
      </View>
      <Text className="flex-2 text-regular text-ink-darkest text-center font-500">{title}</Text>
      <View className="flex-1" />
    </View>
  );
}
